var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuFavorit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 8.77273C1 7.09914 2.25094 5.74242 3.79405 5.74242C5.33716 5.74242 6.5881 7.09914 6.5881 8.77273V18.4697C6.5881 20.1433 5.33716 21.5 3.79405 21.5C2.25094 21.5 1 20.1433 1 18.4697V8.77273Z",
    stroke: "#27AE60",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.584 2.3363L8.09116 6.72978C7.42185 7.90938 7.08719 8.49918 6.88483 9.14551C6.82311 9.34267 6.77079 9.54314 6.72809 9.74613C6.5881 10.4116 6.5881 11.1041 6.5881 12.4892V16.6515C6.5881 19.3293 8.5896 21.5 11.0586 21.5H14.3107C16.4273 21.5 18.3622 20.203 19.3088 18.1498L20.5924 15.3655C21.8604 12.615 20.0163 9.37879 17.1809 9.37879H16.41C14.4777 9.37879 13 7.51075 13.2938 5.43939L13.5654 3.52451C13.7164 2.46001 12.957 1.5 11.964 1.5C11.4013 1.5 10.8789 1.81659 10.584 2.3363Z",
    stroke: "#27AE60",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuFavorit);
export default __webpack_public_path__ + "static/media/menu-favorit.24d033146e2e73549f35c43763ef7c45.svg";
export { ForwardRef as ReactComponent };